/**
 * Runs the tenant save (which owns the industry list) before the settings save, so the
 * API already sees a newly assigned industry when it validates that industry's default
 * My Brand. Markets save last. A failed step skips the steps after it.
 */
export async function saveOrgChanges(steps: {
  saveTenant: (() => Promise<unknown>) | null;
  saveSettings: (() => Promise<unknown>) | null;
  saveMarkets?: (() => Promise<unknown>) | null;
}): Promise<void> {
  if (steps.saveTenant) await steps.saveTenant();
  if (steps.saveSettings) await steps.saveSettings();
  if (steps.saveMarkets) await steps.saveMarkets();
}
